import React from 'react';
import CtaComponent from './cta-component';
import { Box, Typography, useTheme } from '@mui/material';
import AdDisclosure from 'src/components/ad-disclosure';
import {
  EntityName,
  EventType,
  SectionName,
} from 'src/utils/analytics/constants';
import { useImpressionEvent } from 'src/utils/analytics/hooks';
import { JumpPageSectionProps } from '../../jump-page-body';
import { CHRONICLE_DISPLAY } from 'src/components/providers/theme';

const InnerCtaSection: React.FC<JumpPageSectionProps> = ({ analytics }) => {
  const theme = useTheme();
  const { ref } = useImpressionEvent({
    eventType: EventType.ElementImpression,
    navigationId: analytics.navigationId,
    payload: {
      entity_name: EntityName.Flow,
      section_name: SectionName.JumpHeroCta,
      section_position: 0,
    },
  });

  return (
    <Box ref={ref}>
      <Box bgcolor="green.lightest" paddingLeft={4} paddingTop={3}>
        <AdDisclosure />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        bgcolor="green.lightest"
        paddingTop={3}
        paddingBottom={4}
        sx={{
          [theme.breakpoints.down('md')]: {
            paddingX: 3,
          },
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          flexDirection="column"
          sx={{
            [theme.breakpoints.up('sm')]: {
              maxWidth: '70%',
            },
          }}
        >
          <Typography
            textAlign="center"
            variant="bodyLargeBlack"
            marginBottom={2}
            component="h1"
          >
            CardFinder: Credit Card Recommendation Quiz
          </Typography>
          <Typography
            sx={{
              fontSize: 32,
              lineHeight: '111%',
              fontFamily: CHRONICLE_DISPLAY,
              fontWeight: 400,
              [theme.breakpoints.up('md')]: {
                fontSize: 54,
                lineHeight: '53px',
                marginBottom: 2,
              },
            }}
            marginBottom={3}
          >
            Get results in minutes:
          </Typography>
          <CtaComponent analytics={analytics} />
          <Typography
            textAlign="center"
            variant="textSmall"
            marginTop={3}
            marginBottom={2}
          >
            This service is FREE, will not affect your credit score, and no
            contact information is required.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InnerCtaSection;
